module.exports = __webpack_public_path__ + "assets/img/InvestmentAdvisor.a621bb78.png";